import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export function ScrollToTop() {
  const { pathname } = useLocation();
  const prevPathnameRef = useRef(pathname);
  const isInitialMount = useRef(true);

  useEffect(() => {
    // Skip scroll on initial mount (page load/refresh already handles this)
    if (isInitialMount.current) {
      isInitialMount.current = false;
      prevPathnameRef.current = pathname;
      return;
    }

    // Only scroll if the pathname actually changed (not during transition flicker)
    if (prevPathnameRef.current === pathname) {
      return;
    }

    prevPathnameRef.current = pathname;

    // Use requestIdleCallback to scroll after the browser is idle (new route rendered)
    // Fall back to setTimeout for browsers that don't support it
    const scrollToTop = () => {
      window.scrollTo(0, 0);
    };

    if ('requestIdleCallback' in window) {
      const idleId = window.requestIdleCallback(scrollToTop, { timeout: 100 });
      return () => window.cancelIdleCallback(idleId);
    } else {
      // Delay scroll to after the new route has rendered
      const timeoutId = setTimeout(scrollToTop, 50);
      return () => clearTimeout(timeoutId);
    }
  }, [pathname]);

  return null;
}